<template>
  <span v-if="src" :class="['logo', { photo }]"><img :src="src" alt="" width="24" height="24" loading="lazy" :style="position ? { objectPosition: position } : null" /></span>
  <span v-else class="logo initials">{{ initials }}</span>
</template>

<script>
export default {
  name: "CompanyLogo",
  props: { src: String, initials: String, photo: Boolean, position: String },
};
</script>

<style scoped>
.initials {
  font-weight: 800;
  font-size: 13px;
  color: var(--ink-2);
}
</style>
